/** @jsxImportSource @emotion/react */
import "./modal.css";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Modal from "react-modal";
import { theme } from "styles/theme";
import Icon from "uis/Icon";
import { useEffect, useState } from "react";
import { TDevice } from "apis/visitors/device";

import Tab from "./tab";
import DeviceInfo from "./custom-modal/device-info";
import HomeTheme from "./custom-modal/home-theme";
import DoorBell from "./custom-modal/doorbell";
import WalkInVisit from "./custom-modal/walk-in-visit";

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  device: TDevice;
  onChangeDevice: () => void;
};

Modal.setAppElement("#root");

const Heading = styled.p`
  color: ${theme.neutral900};
  font-size: 20px;
  font-weight: 700;
`;

const HeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid ${theme.neutral50};
  padding: 30px 34px 20px 34px;
`;

const modalStyle = {
  content: {
    left: "auto",
    minWidth: 1000,
    width: "70%",
    right: 0,
    top: 0,
    bottom: 0,
    padding: 0,
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};

export default function DeviceInfoModal(props: Props) {
  const [editing, setEditing] = useState<boolean>(false);
  const { modalIsOpen, closeModal, device, onChangeDevice } = props;
  const [currentTab, setCurrentTab] = useState<string>();

  useEffect(() => {
    //탭간 불러오는 api 다르게,
  }, [currentTab]);

  useEffect(() => {
    if (modalIsOpen) {
      setCurrentTab("기기 정보");
    }
  }, [modalIsOpen]);

  const tabData = ["기기 정보", "홈 화면 구성", "초인종", "당일 방문"];

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} closeTimeoutMS={400} style={modalStyle}>
      <HeadingContainer>
        <Heading>{device.deviceName}</Heading>
        <Icon name="close" width={24} height={24} color={theme.neutral900} onClick={closeModal} />
      </HeadingContainer>
      <Tab
        onChange={(item) => setCurrentTab(item)}
        data={tabData}
        selected={currentTab}
        styles={{
          container: css`
            padding: 20px 40px 0 40px;
          `,
        }}
      />
      {currentTab === "기기 정보" && (
        <DeviceInfo
          device={device}
          onChange={onChangeDevice}
          onChangeTab={(value: string) => {
            setCurrentTab(value);
          }}
        />
      )}
      {currentTab === "홈 화면 구성" && <HomeTheme device={device} onChange={onChangeDevice} />}
      {currentTab === "초인종" && <DoorBell device={device} onChange={onChangeDevice} />}
      {currentTab === "당일 방문" && <WalkInVisit device={device} onChange={onChangeDevice} />}
    </Modal>
  );
}
